export enum EProbabilidadeConciliacao {
    Encontrado = 1,
    ValorAproximado = 2,
    DataAproximada = 3,
    SomaVariosTitulos = 4,
    Parecidos = 5,
    SomaVariosMovimentos = 6,
}
